export const environment = {
  production: true,
  base_url: 'http://168.205.92.142:3005/api',
  afipUrl:  'http://168.205.92.142:3006',
  back_url: 'http://168.205.92.142:3005'
};
